import type { DatadogRum } from '@datadog/browser-rum'

import { isBrowser } from '../env'

export const getDatadogRum = async (): Promise<DatadogRum> => {
  if (!isBrowser()) {
    throw new Error('Datadog RUM is only available in the browser')
  }

  if (window?.DD_RUM?.getInitConfiguration()) {
    return window.DD_RUM
  }

  const { datadogRum } = await import('@datadog/browser-rum')
  return datadogRum
}
